import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { IHouseholdInteraction } from 'app/models/household/household-interaction';

import { HouseholdService } from 'app/services/household-service';

import { ToastrService } from 'ngx-toastr';
import { DialogEditHouseholdComponent } from '../../edit/household-edit-dialog';
//import { DialogEditVoucherComponent } from '../../../vouchers/edit/voucher-edit-dialog';

@Component({
  selector: 'household-interactions-approval-needed-report',
  templateUrl: './household-interactions-approval-needed.html',
  styleUrls: ['./household-interactions-approval-needed.scss']
})

export class HouseholdInteractionsApprovalNeededReportComponent implements OnInit {
  loading: boolean = false;
  houseInteractionsReport: IHouseholdInteraction[] = [];

  displayedColumns: string[] = ['HouseholdId', 'Type', 'Result', 'Comment', 'LastUpdated']; 
  dataSource = new MatTableDataSource<IHouseholdInteraction>(this.houseInteractionsReport);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(private householdService: HouseholdService,
    public dialog: MatDialog,
    private toastr: ToastrService ) { 
  }

  ngOnInit(): void {
    this.loadHouseInteractionsReport();
  }

 
  loadHouseInteractionsReport() {
    this.loading = true;

    this.householdService.getHouseholdInteractionsApprovedReport().subscribe(
      result => {
        this.houseInteractionsReport = result;
       
        this.loading = false;
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<IHouseholdInteraction>(this.houseInteractionsReport);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  editHousehold(householdId: number) {
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: householdId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadHouseInteractionsReport();
    });
  }
  
}
 